<template>
    <v-container fluid>
        <v-row>
            <v-col md="6">
              <v-card color="primary" min-height="160">
                <v-card-title class="font-weight-bold">Network Discovery Options</v-card-title>
                  <div class="text-center">
                    <v-menu bottom origin="center center" transition="scale-transition"> 
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ma-2" v-bind="attrs" v-on="on"><v-avatar left><v-icon>fa-eye</v-icon></v-avatar>View Snapshot / Live Network</v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-for="(ele,i) in networkDetails.snapshot" :key="i" v-on:click="loadSnapshot(ele)">
                          <v-list-item-title>{{ displayTimestamp(ele.timestamp) }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <v-menu bottom origin="center center" transition="scale-transition"> 
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ma-2" v-bind="attrs" v-on="on"><v-avatar left><v-icon>fa-wrench</v-icon></v-avatar>Set Baseline Comparison</v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-for="(ele,i) in networkDetails.snapshot" :key="i" v-on:click="setBaseline(ele)">
                          <v-list-item-title>{{ displayTimestamp(ele.timestamp) }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <v-btn class="ma-2" @click="dialog1 = true"><v-avatar left><v-icon>fa-file-download</v-icon></v-avatar>Save Live Snapshot</v-btn>
                  </div>
              </v-card>
           </v-col>
            <v-col md="6">
              <v-flex>
                <networkDetails v-bind:networkDetails="networkDetails"/>
              </v-flex>
           </v-col>
        </v-row>

        <v-row>
            <v-col md="9">
              <v-card id="graph">
                <v-toolbar color="primary" flat>
                  <v-toolbar-title class="font-weight-bold">Network Inspector</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn v-on:click="showNames">
                    <v-avatar left><v-icon>{{ networkNamesUI.icon }}</v-icon></v-avatar>{{ networkNamesUI.text }}
                  </v-btn>
                </v-toolbar>
                <svg></svg>
              </v-card>
            </v-col>
            <v-col md="3">
              <v-container grid-list-lg>
                <v-layout row justify-center>

                  <v-flex>
                      <environmentInformation v-bind:sensorType="sensorType" v-bind:environmentInfo="environmentInfo" v-bind:baselineInfo="baselineInfo"/>
                  </v-flex>

                  <v-flex>
                    <v-card color="primary">
                      <v-card-title class="font-weight-bold">Node Details</v-card-title>
                      <v-simple-table dense>
                        <template v-slot:default>
                          <tbody>
                            <tr v-for="ele in nodeFields" :key="ele.id">
                              <td>{{ ele.id.charAt(0).toUpperCase() + ele.id.slice(1) }}</td>
                              <td>{{ ele.value }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-col>
        </v-row>

        <v-row justify="center">
          <v-dialog v-model="dialog1" max-width="300">
          <v-card>
            <v-card-title class="headline">Save Live Snapshot?</v-card-title>
            <v-card-text>{{ currentTime }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" text @click="saveLiveSnapshot">Save</v-btn>
              <v-btn color="warning" text @click="dialog1 = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
          </v-dialog>
        </v-row>

    </v-container>
</template>

<script>
import * as d3 from "d3";
import _ from "lodash";
import environmentInformation from '@/components/environmentInformation.vue';
import networkDetails from '@/components/networkDetails.vue';

export default {
    components: {
        environmentInformation,
        networkDetails
    },
    props: {
      currentTime: String,
      networkDetails: Object,
      sensorType: Array,
      environmentInfo: Object,
      baselineInfo: Object,
    },
    data: () => ({
      dialog1: false,
      networkNamesUI: {
        visible: false,
        icon: "fa-eye",
        text: "See names"
      },
      nodeFields: [
        { id: "name", value: "" },
        { id: "type", value: "" },
        { id: "ip", value: "" },
        { id: "criticality", value: "" },
        { id: "purdue level", value: "" },
        { id: "related alert", value: "" },
        { id: "status", value: "" },
      ]
    }),
    computed: {
    },
    methods: {
      displayTimestamp(ele) {
        let format = d3.timeFormat("%B %d, %Y %H:%M:%S");
        if (ele != 'Current live network') {
          return format(ele);
        } else {
          return ele;
        }
      },
      saveLiveSnapshot: function() {

        let currentNetwork = Object.assign({}, this.networkDetails.snapshot[this.networkDetails.snapshot.length - 1]);
        this.loadSnapshot(currentNetwork);

        currentNetwork.timestamp = new Date();
        this.networkDetails.snapshot.splice(this.networkDetails.snapshot.length - 1, 0,currentNetwork);
        this.dialog1 = false;
      },
      loadSnapshot: function(ele) {
        this.networkDetails.networkSnapshot = ele.timestamp;

        d3.select("#graph svg").selectAll("*").remove();
        this.drawChart();
      },
      setBaseline: function(ele) {
        //Store Vue environment!
        let that = this;

        this.networkDetails.baselineSnapshot = ele.timestamp;

        d3.json(ele.nodes).then(data => {
          let baselineInfo = _.countBy(data.node, function(ele2) { return ele2.type });
          that.$emit("updateBaselineInfo", baselineInfo);
        })
      },
      drawChart: function() {
        //Store Vue environment!
        let that = this;
        let networkSnapshot = _.find(this.networkDetails.snapshot, {timestamp: this.networkDetails.networkSnapshot});

        Promise.all([d3.json(networkSnapshot.links), d3.json(networkSnapshot.nodes)]).then((data) => {

          // Add source and target tags for D3 force hierachy
          data[0].link.forEach((e) => {
              e.source = e.sender;
              e.target = e.receiver;
          });

          let purdueLevel = [
            {"purdue level": 0, bottom: 0, top: 1},
            {"purdue level": 1, bottom: 1, top: 2},
            {"purdue level": 2, bottom: 2, top: 3},
            {"purdue level": 3, bottom: 3, top: 4},
            {"purdue level": 3.5, bottom: 4, top: 5}
          ];

          let environmentInfo = _.countBy(data[1].node, function(ele) { return ele.type });
          that.$emit("updateEnvironmentInfo", environmentInfo);

          let width = document.getElementById("graph").getBoundingClientRect().width;
          let height = 2/3 * width;

          let colorScheme = d3.scaleOrdinal(d3.schemeSet3);

          let force = d3.forceSimulation(data[1].node)
              .force("charge", d3.forceManyBody().strength(-300))
              .force("center", d3.forceCenter(width / 2, height / 2))
              .force("x", d3.forceX(width / 2))
              .force("y", d3.forceY(height / 2))
              .force("link", d3.forceLink(data[0].link)
                  .id(function(d) {return d.id;})
              )
              .on("tick", tick);

          let svg = d3.select("#graph svg")
              .attr("viewBox", "0 0 " + width + " " + height);

          svg.append("defs")
              .selectAll("marker")
              .data([{type: "link", color: "#333"}, {type: "selected", color: "#0ff"}])
            .enter()
              .append("marker")
              .attr("id", function(d) {return d.type;})
              .attr("viewBox", "0 -5 10 10")
              .attr("refX", 20)
              .attr("refY", -2.5)
              .attr("markerWidth", 6)
              .attr("markerHeight", 6)
              .attr("fill", function(d) {return d.color})
              .attr("orient", "auto")
            .append("path")
              .attr("d", "M0,-5L10,0L0,5 Z");

          let chart = svg.append("g").attr("id", "chart");

          let linkpath = chart.append("g").attr("id", "links")
              .selectAll("path")
              .data(data[0].link)
            .enter().append("path")
              .attr("class", function(d) { return "link";})
              .attr("marker-end", function(d) { return "url(#link)"; });

          let nodes = chart.append("g").attr("id", "nodes")
              .selectAll("g")
              .data(data[1].node)
            .enter()
              .append("g");

          let circle = nodes.append("circle")
              .attr("class", "node")
              .attr("r", 10)
              .attr("fill", function(d) {return colorScheme(d["purdue level"]); })
              .attr("stroke", function(d) {if (d.status != "normal") { return "#f00" } else {return "#000"} })
              .attr("stroke-width", function(d) {if (d.status != "normal") { return "2.5px" } else {return "1px"} })
              .on("mouseover", function(d) {
                  d3.select(this).attr("class", "node selected");
                  linkpath
                  .attr("class", function(e) {
                      if (e.source.id == d.id || e.target.id == d.id) { return "link selected"; } else { return "link"; }
                  })
                  .attr("marker-end", function (e) {
                      if (e.source.id == d.id || e.target.id == d.id) { return "url(#selected)"; } else { return "url(#link)"; }
                  });
                  that.nodeFields[0].value = d.name;
                  that.nodeFields[1].value = d.type;
                  that.nodeFields[2].value = d.ip;
                  that.nodeFields[3].value = d.criticality;
                  that.nodeFields[4].value = d["purdue level"];
                  that.nodeFields[5].value = d["related alert"];
                  that.nodeFields[6].value = d.status;
              })
              .on("mouseout", function(d) {
                  d3.select(this).attr("class", "node");
                  linkpath
                  .attr("class", "link")
                  .attr("marker-end", "url(#link)") ;
                  that.nodeFields.forEach(function(ele){
                    ele.value = "";
                  })
              })
              .call(d3.drag()
                  .on("start", dragstarted)
                  .on("drag", dragged)
                  .on("end", dragended));

          let image = nodes.append("image")
                  //arrow function *this* refers to global scope
              .attr("xlink:href", (d) => { return _.find(this.sensorType, {type: d.type}).image })
              .attr("width", 15)
              .attr("height", 15)
              .attr("pointer-events", "none");

          let text = nodes
              .append("text")
              .attr("text-anchor", "start")
              .attr("visibility", "hidden")
              .text(function(d) { return d.name; });

          svg.call(
              d3.zoom()
                  .scaleExtent([.5, 2])
                  //.translateExtent([[-200,-200],[width + 200,height]])
                  .on("zoom", function() {
                      chart.attr("transform", d3.event.transform );
                      d3.select("svg").attr("cursor", "grabbing");
                  })
                  .on("end", function() {
                      d3.select("svg").attr("cursor", "default");
                  })
          );

    let legend = svg.append("g")
        .attr("id", "legend")
        .attr("transform", "translate(30, " + (height - purdueLevel.length * 25)+ ")");

        legend.selectAll("circle")
        .data(purdueLevel)
      .enter().append("circle")
        .attr("r", 10)
        .attr("cx", 0)
        .attr("cy", function(d,i) {return i * 25})
        .attr("fill", (function(d, i) {return colorScheme(i)} ))
        .attr("stroke", "#000");

        legend.selectAll("text")
        .data(purdueLevel)
      .enter().append("text")
        .attr("x", 20)
        .attr("y", function(d,i) {return i * 25 + 2})
        .text(function(d) { return "Purdue Level: " + d["purdue level"]} );

        if (this.networkNamesUI.visible) {
            d3.selectAll("svg g#chart g#nodes text").attr("visibility", "visible");
        } else {
            d3.selectAll("svg g#chart g#nodes text").attr("visibility", "hidden");
        }

          // Use elliptical arc path segments to doubly-encode directionality.
          function tick() {
            linkpath.attr("d", function(d) {
                var dx = d.target.x - d.source.x,
                    dy = d.target.y - d.source.y,
                    dr = Math.sqrt(dx * dx + dy * dy);

                return "M" + d.source.x + "," + d.source.y + "A" + dr + "," + dr + " 0 0 1 " + d.target.x + "," + d.target.y;
            });

            circle
              .attr("cx", function(d) { return d.x; })
              .attr("cy", function(d) { return d.y; });

            image
              .attr("x", function(d) { return d.x - 7.5; })
              .attr("y", function(d) { return d.y - 7.5; });

            text
              .attr("x", function(d) { return d.x + 12; })
              .attr("y", function(d) { return d.y + 3; });
          }

          function dragstarted(d) {
            if (!d3.event.active) force.alphaTarget(0.3).restart()
            d.fx = d.x;
            d.fy = d.y;
          }

          function dragged(d) {
            d.fx = d3.event.x;
            d.fy = d3.event.y;
          }

          function dragended(d) {
            if (!d3.event.active) force.alphaTarget(0);
            d.fx = null;
            d.fy = null;
          }

        })
      },
      showNames: function () {
        if (this.networkNamesUI.visible) {
            d3.selectAll("svg g#chart g#nodes text").attr("visibility", "hidden");
            this.networkNamesUI.visible = false;
            this.networkNamesUI.icon = "fa-eye";
            this.networkNamesUI.text = "See names";
        } else {
            d3.selectAll("svg g#chart g#nodes text").attr("visibility", "visible");
            this.networkNamesUI.visible = true;
            this.networkNamesUI.icon = "fa-eye-slash";
            this.networkNamesUI.text = "Hide names";
        }
      }
    },
    mounted: function() {
      this.drawChart();
    }
}
</script>

<style>
.link {
  fill: none;
  stroke: #666;
  stroke-width: 1.5px;
}

.link.selected {
  stroke: #0ff;
}

#selectedLink {
  fill: #0ff;
}

.node.selected {
  stroke: #0ff;
  stroke-width: 2px;
}

.levelText {
  font-size: 20px;
  fill: #000;
  text-transform: uppercase;
}

text {
  font: 10px Verdana, sans-serif;
  pointer-events: none;
}
</style>